import { useOnboardingStore } from '@/store/onboardingStore';
import { ChipGroup } from '../components/ChipGroup';
import type { DominatePosition } from '@/types/onboarding';

const POSITION_OPTIONS: { value: DominatePosition; label: string; icon: string }[] = [
    { value: 'neutral', label: 'On My Feet', icon: '👟' },
    { value: 'top', label: 'On Top', icon: '🏔️' },
    { value: 'scramble', label: 'In Scrambles', icon: '🌪️' },
    { value: 'counter', label: 'Counter Wrestling', icon: '🛡️' },
];

export function DefenseScreen() {
    const { profile, setDominatePosition, nextStep } = useOnboardingStore();

    const handleSelect = (val: string | string[]) => {
        const selected = Array.isArray(val) ? val[0] : val;
        setDominatePosition(selected as DominatePosition);
        setTimeout(nextStep, 300);
    };

    return (
        <div className="px-2 animate-fade-in-right">
            <h2 className="text-xl font-bold text-text-primary mb-2">
                Dominant Position
            </h2>
            <p className="text-text-secondary text-sm mb-6">
                Where do you feel most comfortable?
            </p>

            <ChipGroup
                options={POSITION_OPTIONS}
                selected={profile.dominatePosition || ''}
                onChange={handleSelect}
                columns={2}
            />
        </div>
    );
}
